import type { Document } from '@gitbook/slate';

import { isBlockEmpty } from './isBlockEmpty';

/**
 * Trim empty content from a value.
 */
export function trimDocument(document: Document): Document {
    const { nodes } = document;
    const newNodes = nodes
        .skipWhile((node) => isBlockEmpty(node, { trim: true }))
        .reverse()
        .skipWhile((node) => isBlockEmpty(node, { trim: true }))
        .reverse();

    return document.merge({
        nodes: newNodes,
    });
}
